import { render, staticRenderFns } from "./LegalNotes.vue?vue&type=template&id=deebe3c6&"
import script from "./LegalNotes.vue?vue&type=script&lang=js&"
export * from "./LegalNotes.vue?vue&type=script&lang=js&"
import style0 from "./LegalNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports